import type { SVGProps } from 'react';

const ContrastIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.91 2.25L2.25 8.91V11.0325L11.0325 2.25H8.91ZM14.6326 2.30859L2.31006 14.6311C2.37756 14.8861 2.51256 15.1186 2.69256 15.3061C2.88006 15.4861 3.11256 15.6211 3.36756 15.6886L15.6976 3.36609C15.5551 2.84859 15.1501 2.44359 14.6326 2.30859ZM2.25 3.75C2.25 2.925 2.925 2.25 3.75 2.25H5.25L2.25 5.25V3.75ZM14.25 15.75C14.6625 15.75 15.0375 15.585 15.3075 15.3075C15.585 15.0375 15.75 14.6625 15.75 14.25V12.75L12.75 15.75H14.25ZM9.09 15.75H6.9675L15.75 6.9675V9.09L9.09 15.75Z"
      fill={props?.fill ?? "#696F88"}
    />
  </svg>
);

export default ContrastIcon;
